// Namespaced $(document).ready
window.sfDocumentReady = (routes = [], callback = () => {}) => {
  // Call if routes is empty or current route matches any of the routes
  if (
    !routes.length ||
    routes.some(route => document.body.classList.contains(route))
  ) {
    $(callback); // doc.ready
  }
};

window.sfDocumentReady([], () => {
  window.httpGet = (url, data, callbacks) => {
    $.ajax({
      url,
      data,
      type: 'GET',
      dataType: 'json',
      error: callbacks.error,
      success: callbacks.success,
      complete: callbacks.complete
    });
  };

  window.httpDelete = (url, { error, success, complete }) => {
    $.ajax({
      url,
      type: 'DELETE',
      dataType: 'json',
      error,
      success,
      complete
    });
  };

  window.httpPost = (
    url,
    data,
    callbacks,
    processData = true,
    contentType = 'application/x-www-form-urlencoded; charset=UTF-8'
  ) => {
    $.ajax({
      url,
      data,
      type: 'POST',
      dataType: 'json',
      error: callbacks.error,
      success: callbacks.success,
      complete: callbacks.complete,
      processData,
      contentType,
    });
  };

  window.getData = (url, data = false) => {
    data = data || $('#sort_filter').serialize();

    $.ajax({
      url,
      data,
      type: 'POST',
      dataType: 'html',
      success(response) {
        $('.js-datatable-body').html(response);
        if (typeof window.setupDatatable === 'function') {
          window.setupDatatable();
        }

        const count = $('#totalCount').val();
        if (count !== undefined) {
          $('.totalCount').html(count);
        }
      }
    });
  };

  // Notification using Noty
  window.notifyBox = (title, text, type) => {
    new Noty({
      type,
      text: `<div class="text-bold text-capitalize sf-mb-1">${title}</div>${text}`,
      theme: 'semanticui',
      timeout: 5000
    }).show();
  };

  window.downloadLinks = (links) => {
    if (!links || !links.length) {
      throw TypeError('No links provided to be downloaded')
    }

    const virtualLinks = links.map(link => $('<a />', {
      href: link,
      download: 'download',
      css: {
        display: 'none'
      }
    }));

    // Safari disallows multiple download links from triggering click at the same time
    // so we put a small delay in between to fix it
    const delayBetweenDownloads = 50;

    // Note: links don't need to be added into body before triggering click (download)
    $(virtualLinks)
      .each((index, link) => setTimeout(() => link.get(0).click(), index * delayBetweenDownloads)) // queue downloads
      .remove(); // clean temporary elements
  }

  function sessionExpired() {
    const csrf = $(document)
      .find('meta[name="csrf-token"]')
      .attr('content');
    Swal.fire({
      title: 'Session expired',
      html:
        `${'<h2>Please login again to continue</h2><form class="sf-m-3 sf-mt-8" id="loginForm" action="/login" method="POST">' +
          '<input type="hidden" name="_token" value="'}${csrf}">` +
        `<input type="hidden" name="redirect" value="${window.location.pathname}">` +
        '<div class="flow-root"></div>' +
        '<div class="form-group">' +
        '<div class="ffl-wrapper sf-mb-4 ffl-floated ffl-floated-pre">' +
        '<label class="ffl-label ffl-offset-label" for="emailField">Email</label>' +
        '<input type="email" id="emailField" class="js-login-email form-control icon-mail" name="email" value="">' +
        '</div>' +
        '<div class="ffl-wrapper ffl-floated ffl-floated-pre">' +
        '<label class="ffl-label ffl-offset-label" for="password">Password</label>' +
        '<input type="password" class="js-login-pw form-control icon-password" name="password" id="password" value="">' +
        '</div>' +
        '<div class="sf-mt-8">' +
        '<button type="submit" class="btn btn-info pull-right">Login</button>' +
        '<button type="button" id="modal-magic-link" class="js-login-magic btn btn-submit pull-right sf-mr-4">Generate magic link</button>' +
        '</div>' +
        '<div class="flow-root"></div>' +
        '</div>' +
        '</form>',
      focusConfirm: false,
      showConfirmButton: false,
      customClass: {
        title: 'sf-text-orange'
      },
      onOpen() {
        $(document)
          .find('#modal-magic-link')
          .on('click', generateMagicLink);
      }
    });
  }

  window.ajaxErrorHandler = status => {
    if (status === 401 || status === 403) {
      sessionExpired();
      return true;
    }
  };

  $.ajaxSetup({
    // CSRF protection for AJAX requests
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },

    // Loading
    beforeSend() {
      $('.js-loading').show();
      $('.js-submit-button').prop('disabled', true);
    },

    // Error handler
    error(response, status, error) {
      if (ajaxErrorHandler(response.status)) {
        return;
      }

      notifyBox(`Error (${response.status})`, error, 'error');

      // Hide loading afterwards
      $('.js-loading').hide();
    },

    // Hide loading afterwards
    complete() {
      $('.js-loading').hide();
      $('.js-submit-button').prop('disabled', false);
    }
  });

  window.Api = new window.axios.create({
    baseURL: '/',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    }
  });

  // Request interceptor
  window.Api.interceptors.request.use(function (config) {
    $('.js-loading').show();
    return config;
  }, function (error) {
    return Promise.reject(error);
  });

  // Response interceptor
  window.Api.interceptors.response.use(function (response) {
    $('.js-loading').hide();
    return response;
  }, function (error) {
    $('.js-loading').hide();
    return Promise.reject(error);
  });
});
